ixModuleRouting("impactx.productview", {
    "/productviewlist": {
        template: "<ixa-productview-list></ixa-productview-list>",
        process: "ListProductView",
        workspace: "admin",
    },
    "/productview/:id/:activate?": {
        template: "<ixa-product-view></ixa-product-view>",
        process: "ViewProductView",
        workspace: "admin",
    },
    "/productviewtenders/:id": {
        template: "<ixa-product-view-tenders></ixa-product-view-tenders>",
        process: "ViewProductView",
        workspace: "admin",
    },
    "/productviewlots/:id": {
        template: "<ixa-product-view-lots></ixa-product-view-lots>",
        process: "ViewProductView",
        workspace: "admin",
    },
    "/productviewvcats/:id": {
        template: "<ixa-product-view-vcats></ixa-product-view-vcats>",
        process: "ViewProductView",
        workspace: "admin",
    },
    "/productviewsuppliers/:id": {
        template: "<ixa-product-view-suppliers></ixa-product-view-suppliers>",
        process: "ViewProductView",
        workspace: "admin",
    },
});
